export interface IUser {
  uid: string;
  umail: string;
  ufnm?: string;
  ulnm?: string;
  ufingerprint: string;
  access_token?: string;
  sessionUID: string;
  lastActivity?: Date;
  RobotsRole?: UserRolesEnum;
  userPosition?: IUserPosition;
  systemVersion: string;
}

export interface IUserPosition {
  accountantId?: string;
  organizationId?: string;
  fileId?: string;
}

export enum UserRolesEnum {
  superAdmin = 'SuperAdmin',
  admin = 'Admin',
  robotsManager = 'RobotsManager',
  user = 'User',
}

export enum UserPermissionsEnum {
  createRobot,
}
